var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetailer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EDEFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2049 14.8783C23.0695 14.8956 22.9306 14.9061 22.7848 14.9061C21.8802 14.9061 21.0761 14.5109 20.5212 13.9002C19.9723 14.5102 19.1667 14.9061 18.2605 14.9061C17.3559 14.9061 16.55 14.5109 15.998 13.9002C15.4445 14.5102 14.6424 14.9061 13.7327 14.9061C12.8278 14.9061 12.0223 14.5109 11.4702 13.9002C10.9202 14.5102 10.1146 14.9061 9.20698 14.9061C9.06611 14.9061 8.924 14.8962 8.78615 14.8781C6.86531 14.6213 5.95643 12.3574 6.98372 10.7324L8.974 7.58383C9.15125 7.30085 9.4674 7.12793 9.8049 7.12793H22.1938C22.5311 7.12793 22.8473 7.30078 23.0247 7.58383L25.015 10.7324C26.0452 12.3609 25.132 14.6213 23.2049 14.8783Z",
    fill: "#545D78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.7778 14.7259L23.7813 23.2398C23.7813 24.1603 23.0351 24.9065 22.1458 24.9065H9.88889C8.96841 24.9065 8.25347 24.1603 8.25347 23.2398L8.22327 14.7259C8.40184 14.7943 8.58403 14.8511 8.78611 14.8783C8.92396 14.8961 9.06597 14.9065 9.20695 14.9065C9.64931 14.9065 10.0653 14.8097 10.4413 14.6428V20.462H21.5556V14.6426C21.9306 14.8092 22.3472 14.9065 22.7847 14.9065C22.9285 14.9065 23.0664 14.897 23.2045 14.8789C23.4132 14.8509 23.5972 14.7954 23.7778 14.7259Z",
    fill: "#545D78"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailer);
export default __webpack_public_path__ + "static/media/retailer.c1ac4095813daf70f01c50ef79031d54.svg";
export { ForwardRef as ReactComponent };